import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class ScheduleService {
  private _baseUrl: string;

  constructor(private http: HttpClient) {
    this._baseUrl = environment.apiUrl;
  }

  createSchedule(newScheduleForm) {
    return this.http.post<any>(this._baseUrl + 'scheduledExecutions/', newScheduleForm);
  }

  updateSchedule(newScheduleForm) {
    return this.http.put<any>(this._baseUrl + 'scheduledExecutions/', newScheduleForm);
  }

  deleteSchedule(id) {
    return this.http.delete<any>(this._baseUrl + 'scheduledExecutions/' + id);
  }
  deleteMultipleSchedules(scheduleIdList: number[]): Observable<any> {
    const options = {
      body: { scheduleIdList }
    };
    return this.http.delete<any>(`${environment.apiUrl}scheduledExecutions/bulkDelete`, options);
  }
  getSchedule(id) {
    return this.http.get<any>(this._baseUrl + 'scheduledExecutions/' + id);
  }

  getEndPointSchedules(moduleId) {
    return this.http.get<any>(this._baseUrl + 'scheduledExecutions/endPoints/' + moduleId);
  }

  getTestCaseSchedules(moduleId): any {
    return this.http.get<any>(this._baseUrl + 'scheduledExecutions/testCases/' + moduleId);
  }

  getTestSuiteSchedules(moduleId): any {
    return this.http.get<any>(this._baseUrl + 'scheduledExecutions/testSuites/' + moduleId);
  }

  getMasterSuiteSchedules(moduleId): any {
    return this.http.get<any>(this._baseUrl + 'scheduledExecutions/masterSuites/' + moduleId);
  }

  getResults(scheduledExecutionId: any, currentPage: number, size: number, executionType: string) {
    const url = (`${this._baseUrl}result/scheduledExecutions/${scheduledExecutionId}/${currentPage}/${size}?executionType=${executionType}`);
    return this.http.get<any>(url);
  }

  getResultsByStatus(scheduledExecutionId, currentPage: number, size: number, status: string, executionType: string) {
    const url = (`${this._baseUrl}result/scheduledExecutions/${scheduledExecutionId}/${currentPage}/${size}/?status=${status}&executionType=${executionType}`);
    return this.http.get<any>(url);
  }

  getScheduledExecutionsByUser(data) {
    return this.http.post<any>(this._baseUrl + 'scheduledExecutions/byOwner', data);
  }
  saveBulkSchedules(obj: any) {
    return this.http.put<any>(this._baseUrl + 'scheduledExecutions/updateInBulk', obj);
  }
}
